import { z } from 'zod';

export const mapStatusSchema = z.enum(['Mapped', 'Ignored']);

export type MapStatusSchema = z.infer<typeof mapStatusSchema>;
